import { createSvgIcon } from "@mui/material";

const CheckboxIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_979_43499)">
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="#101828" />
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#101828" />
      <path
        d="M14.6673 6.5L8.25065 12.9167L5.33398 10"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_979_43499">
        <rect width="20" height="20" rx="10" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  "Checkbox"
);

export default CheckboxIcon;
